/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

export default interface KontaktformularDialogState {
    betreff: string;
    text: string;
    isOpen: boolean;
}

export const createInitialState = (): KontaktformularDialogState => ({
    betreff: "",
    text: "",
    isOpen: false,
});
